import moment from "moment";
import { baseUrl, roleId, sourcesTitlePromo } from "../constants/app";
import { isEmpty } from "lodash";

export function declOfNum(number, titles) {  
    const cases = [2, 0, 1, 1, 1, 2];  
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
}

export function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const getImageUrl = (image) => image ? `${baseUrl}${image.url}` : '';

export const getFileUrl = (file) => file ? `${baseUrl}${file.url}` : '';

export const createFormData = (data) => {
    const formData = new FormData();
    const result = {};
    Object.entries(data).forEach(([key, value]) => {
        if (key === 'image' || key === 'imagePrev' || key === 'file' || key === 'secondImage' || key === 'imageAgg') {
            if (value) {
                formData.append(`files.${key}`, value, value.name);
            } else {
                console.warn(`Значение для ${key} равно null`);
                result[key] = null
            }
        } else {
            result[key] = value;
        }
    });
    formData.append('data', JSON.stringify(result));
    return formData;
}

export const getNewPrice = (price = 0, condition, value = 0, persent, active = true) => {
    if (!price) return 0;
    if (!active) return price
    if (condition === 'equal') return value;
    if (persent) {
        const persentPrice = Math.round(price * (value / 100));
        if (condition === 'plus') {
            return price + persentPrice;
        }
        return price - persentPrice;
    } else {
        if (condition === 'plus') {
            return price + value;
        }
        if (condition === 'multiply') {
            return price * value;
        }
        return price - value;
    }
};

export const validatePromotions = (currentCity, deliveryMethod, sum, historyOrders, isChangePromo) => (item) => {
    const currentDate = moment();
    const {
        cities, startDate, endDate, startTimeDate, endTimeDate, prevOrderDays, delivery, minPrice,
    } = item;

    if (!isEmpty(cities)) {
        if (!currentCity || !currentCity.id) return false;
        const citiesList = cities.map((city) => city.id ? city.id : city);
        if (!citiesList.includes(currentCity.id)) return false;
    }

    const startDateBase = startDate ? startDate.split('.')[0] : null;
    const endDateBase = endDate ? endDate.split('.')[0] : null;
    const startTimeDateBase = startTimeDate ? startTimeDate.split('.')[0] : null;
    const endTimeDateBase = endTimeDate ? endTimeDate.split('.')[0] : null;

    if (parseFloat(sum)  < parseFloat(minPrice)) return false;

    if (delivery !== 'all' && delivery !== deliveryMethod) return false;
    
    if (startDateBase && !endDateBase) {
        if (moment(currentDate).isBefore(moment(startDateBase))) return false;
    }
    
    if (!startDateBase && endDateBase) {
        if (moment(currentDate).isAfter(moment(endDateBase))) return false;
    }
    
    if (startDateBase && endDateBase) {
        if (!moment(currentDate).isBetween(startDateBase, endDateBase)) return false;
    }
    
    if (isChangePromo && startTimeDateBase && endTimeDateBase) {
        const timeFormat = 'HH:mm';
        const startTime = moment(startTimeDateBase).format(timeFormat);
        const endTime = moment(endTimeDateBase).format(timeFormat);
    
        const beforeTime = moment(`2000-01-01 ${startTime}`);
        const afterTime = moment(`2000-01-01 ${endTime}`);
        const currentTime = moment().format(timeFormat);
        const now = moment(`2000-01-01 ${currentTime}`);
    
        if (!now.isBetween(beforeTime, afterTime)) return false;
    }
    
    if (prevOrderDays) {
        if (!historyOrders) return false;
        const lastOrder = !isEmpty(historyOrders) ? historyOrders[0] : null;
        if (!lastOrder) return false;
        const prevDay = moment().subtract(prevOrderDays, 'd');
        const lastOrderDate = moment(lastOrder.created_at);
        const isValid = moment(lastOrderDate).isBetween(prevDay, currentDate);
    
        return isValid;
    }
    
    return true;
};

export const validatePromocode = (promocode, deliveryMethod, city, goodsPrice, source, isChangePromo) => {
    if (!promocode.active || promocode.status === 'deactivated') return 'Данный промокод недействителен';
    if (promocode.status === 'activated') return 'Данный промокод уже был активирован';
    if (source && promocode.sources && source !== 'marketing') {
        const sources = promocode.sources.split(' ');
        if (!sources.includes(source)) return `Можно использовать только через: ${sources.map((item) => sourcesTitlePromo[item]).join(', ')}`
    }
    if (goodsPrice < +promocode.minPrice) return `Минимальная сумма заказа для активации данного промокода ${promocode.minPrice} ₽`;
    if (promocode.delivery !== 'all' && deliveryMethod !== promocode.delivery) return 'Данный промокод недействителен для данного способа доставки';
    if (!isEmpty(promocode.cities)) {
        const citiesIds = promocode.cities.map((item) => item.id ? item.id : item)
        if (!citiesIds.includes(city.id)) return 'Данный промокод недействителен в этом регионе';
    }
    if (promocode.startDate && !promocode.endDate) {
      if (moment(new Date()).isBefore(moment(promocode.startDate))) {
        return 'Дата начала промокода не наступила';
      }
    }
    if (!promocode.startDate && promocode.endDate) {
      if (moment(new Date()).isAfter(moment(promocode.endDate))) {
        return 'Промокод уже недействителен';
      }
    }
    if (promocode.startDate && promocode.endDate) {
      if (!moment(new Date()).isBetween(promocode.startDate, promocode.endDate)) {
        return 'Данный промокод недействителен';
      }
    }
  
    if (isChangePromo && promocode.startTimeDate && promocode.endTimeDate) {
      const timeFormat = 'HH:mm';
      const startTime = moment(promocode.startTimeDate).format(timeFormat);
      const endTime = moment(promocode.endTimeDate).format(timeFormat);
  
      const beforeTime = moment(`2000-01-01 ${startTime}`);
      const afterTime = moment(`2000-01-01 ${endTime}`);
      const currentTime = moment().format(timeFormat);
      const now = moment(`2000-01-01 ${currentTime}`);
  
      if (!now.isBetween(beforeTime, afterTime)) {
        return `Промокод работает c ${startTime} по ${endTime}`;
      }
    }
  
    return null;
};

export const checkSorucePromotions = (role) => {
    if ([roleId.coordinator, roleId.operator].includes(role)) return 'cc';
    if ([roleId.manager, roleId.cashier, roleId.regionalDirector].includes(role)) return 'cassa';
    return 'marketing';
}

export const parseNumToFixed = (num, fix = 2) => {
    if (num !== 0 && !num) return null;
    const parseNum = parseFloat(num);
    if (!parseNum) return num;
    const result = parseNum.toFixed(fix || 2);
    if (result == null) return parseNum;
    return +result || result;
}

export const formatNumberWithSpaces = (value) => {
    if (value === null || value === undefined || value === '') return '0';
    const num = Number(value);
    if (isNaN(num)) return '0';
    return num.toLocaleString('ru-RU');
}

export const roundToFixed = (num, fix = 2) => {
    if (typeof num !== 'number' || isNaN(num) || !isFinite(num)) return num;
    if (num === 0) return 0;
  
    const round = (value, decimals) => parseFloat(value.toFixed(decimals));
    let result = round(num, fix);
  
    if (Math.abs(result) > 1e-12) return Number.isInteger(result) ? Math.round(result) : result
  
    let decimals = fix + 1;
    const maxDecimals = 20;
  
    while (decimals <= maxDecimals) {
      const candidate = round(num, decimals);
      if (Math.abs(candidate) > 1e-12) return Number.isInteger(candidate) ? Math.round(candidate) : candidate;
      decimals++;
    }
  
    return 0;
}

export const comparisonVersionExtension = (currentVersion, minVersion) => {
    const toNumbers = (v) => v.split('.').map(Number);
    const versionParts = toNumbers(currentVersion);
    const minParts = toNumbers(minVersion);
    const maxLen = Math.max(versionParts.length, minParts.length);
  
    for (let i = 0; i < maxLen; i++) {
      const versionNum = versionParts[i] || 0;
      const minNum = minParts[i] || 0;
      if (versionNum > minNum) return true;
      if (versionNum < minNum) return false;
    }
    return true;
  }